import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { message, Spin } from 'antd';
import moment from 'moment';

import { getImageData } from '../../redux/action/common/CommonActions';
import {
  getAllImagesForProcessing,
  changeGroupImagesContainerData,
  saveMultipleImagesStatus,
  setImageGroupCount,
  setImageWorkingIds,
  saveMultipleOfflineImagesIDs
} from '../../redux/action/images/ImagesActions';
import ImagesContainer from './components/ImagesContainer';

import './ImagesPage.css';
import { getLoggedUserStatisticData } from '../../redux/action/user/UserActions';

class ImagesPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stepNumber: 0
    };
  }

  componentDidMount() {
    this.props.getAllImagesForProcessing().then(() => {
      if (!_.isEmpty(this.props.pendingIds)) {
        const realImagePages = Math.ceil(
          this.props.pendingIds.length /
            parseInt(process.env.REACT_APP_IMAGES_PER_PAGE)
        );
        const chunkedImagesData = _.chunk(
          this.props.pendingIds,
          parseInt(process.env.REACT_APP_IMAGES_PER_PAGE)
        );
        for (let i = 0; i < realImagePages; i++) {
          this.prepareGroupData(
            `img_group_${i}`,
            chunkedImagesData[i].length,
            this.props.pendingIds,
            i,
            (groupData) => {
              Promise.resolve(
                this.props.changeGroupImagesContainerData(groupData, null)
              ).then(() => {
                Promise.resolve(
                  this.props.setImageWorkingIds(
                    `img_group_${i}`,
                    groupData[`img_group_${i}`].map(
                      (item) => item[Object.keys(item)[0]].imageData.id
                    )
                  )
                );
              });
            }
          );
        }
      } else {
        message.error({
          content: 'No data. Please contact your system administrator.',
          className: 'custom-class',
          style: {
            marginTop: '20vh'
          }
        });
      }
    });

    if (!this.props.userInfo.userPermissions.imagePermission) {
      window.location = '/403';
    }

    // this.props
    //   .getLoggedUserStatisticData(
    //     moment().format('YYYY-MM-DD'),
    //     moment().format('YYYY-MM-DD')
    //   )
    //   .then(() => {
    //     setInterval(this.runUserStatisticDataScheduler, 60000);
    //   });
  }

  componentWillUnmount() {
    message.destroy();
  }

  runUserStatisticDataScheduler = () => {
    this.props.getLoggedUserStatisticData(
      moment().format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    );
  };

  handleRouteTo = (path) => {
    window.location.pathname = path;
  };

  prepareGroupData = (
    groupIndex,
    imagesPerPage,
    allImagesData,
    coefficient,
    callback = null
  ) => {
    let groupData = {
      [groupIndex]: []
    };

    Promise.resolve(this.props.setImageGroupCount(groupIndex, imagesPerPage));

    for (let y = 0; y < imagesPerPage; y++) {
      Promise.resolve(
        this.getImagePreparedData(
          allImagesData[y + coefficient * imagesPerPage],
          (data) => {
            groupData[groupIndex].push(data);
            callback(groupData);
          }
        )
      );
    }
  };

  getImagePreparedData = (imageIndex, callback = null) => {
    let imageDataObject = {};

    this.props.getImageData(imageIndex).then(() => {
      imageDataObject = _.merge({}, imageDataObject, {
        [`img_data_${imageIndex}`]: {
          imageStatus: null,
          notIdenticalStatus: false,
          imageData: this.props.imageData,
          originImageSource: {
            header: '',
            base64Data: null
          },
          downloadedImageSource: {
            header: '',
            base64Data: null
          }
        }
      });

      callback && callback(imageDataObject);
    });
  };

  handleFinish = (confirmData) => {
    let nextStepNumber = _.cloneDeep(this.state.stepNumber);
    let preparedValueForSave = _.map(confirmData.validImagesData, (image) => {
      let imageKey = Object.keys(image)[0];
      if (image[imageKey].imageStatus === null) {
        image[imageKey].imageStatus = 'OFFLINE';
      }
      return {
        id: image[imageKey].imageData.id,
        status: image[imageKey].imageStatus
      };
    });

    this.props.saveMultipleImagesStatus(preparedValueForSave).then(() => {
      if (!_.isEmpty(confirmData.errorImagesIds)) {
        Promise.resolve(
          this.props.saveMultipleOfflineImagesIDs(confirmData.errorImagesIds)
        );
      }
      if (this.props.saveMultipleImagesStatusErrorMessage) {
        message.error(this.props.saveMultipleImagesStatusErrorMessage, 4);
      } else {
        message.success('Images information saved successfully', 4);
        const pendingLimit = parseInt(
          process.env.REACT_APP_AMOUNT_PENDING_LIMIT
        );
        const imagePerPage = parseInt(process.env.REACT_APP_IMAGES_PER_PAGE);
        nextStepNumber++;
        this.setState(
          {
            stepNumber: nextStepNumber
          },
          () => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            let needToLoadNexIds = !(
              (this.state.stepNumber + 1) %
              (pendingLimit / imagePerPage)
            );
            let nextGroupImagesId = Object.keys(
              this.props.imageGroupCount
            ).length;

            if (needToLoadNexIds) {
              this.props.getAllImagesForProcessing().then(() => {
                if (!_.isEmpty(this.props.pendingIds)) {
                  const chunkedImagesData = _.chunk(
                    this.props.pendingIds,
                    parseInt(process.env.REACT_APP_IMAGES_PER_PAGE)
                  );
                  let counter = 0;
                  while (chunkedImagesData[counter]) {
                    this.prepareGroupData(
                      `img_group_${nextGroupImagesId + counter}`,
                      chunkedImagesData[counter].length,
                      this.props.pendingIds,
                      counter,
                      (groupData) => {
                        Promise.resolve(
                          this.props.changeGroupImagesContainerData(
                            groupData,
                            null
                          )
                        );
                      }
                    );
                    counter++;
                  }
                } else {
                  message.error({
                    content:
                      'No data. Please contact your system administrator.',
                    className: 'custom-class',
                    style: {
                      marginTop: '20vh'
                    }
                  });
                }
              });
            } else {
              Promise.resolve(
                this.props.changeGroupImagesContainerData(
                  {},
                  `img_group_${this.state.stepNumber - 1}`
                )
              );
              if (
                this.state.stepNumber ===
                Object.keys(this.props.imageGroupCount).length
              ) {
                this.props.getAllImagesForProcessing().then(() => {
                  if (!_.isEmpty(this.props.pendingIds)) {
                    const chunkedImagesData = _.chunk(
                      this.props.pendingIds,
                      parseInt(process.env.REACT_APP_IMAGES_PER_PAGE)
                    );
                    let counter = 0;
                    while (chunkedImagesData[counter]) {
                      this.prepareGroupData(
                        `img_group_${nextGroupImagesId + counter}`,
                        chunkedImagesData[counter].length,
                        this.props.pendingIds,
                        counter,
                        (groupData) => {
                          Promise.resolve(
                            this.props.changeGroupImagesContainerData(
                              groupData,
                              null
                            )
                          );
                        }
                      );
                      counter++;
                    }
                  } else {
                    message.error({
                      content:
                        'No data. Please contact your system administrator.',
                      className: 'custom-class',
                      style: {
                        marginTop: '20vh'
                      }
                    });
                  }
                });
              }
            }
          }
        );
      }
    });
  };

  render() {
    const { userInfo, loggedUserStatisticData } = this.props;
    return (
      <div className='ImagesDemoPage'>
        <Spin
          className='spinner-block'
          spinning={
            !this.props.groupImagesWorkData.hasOwnProperty(
              `img_group_${this.state.stepNumber}`
            ) ||
            this.props.groupImagesWorkData[`img_group_${this.state.stepNumber}`]
              .length !==
              this.props.imageGroupCount[
                `img_group_${this.state.stepNumber}`
              ] ||
            this.props.saveMultipleImagesStatusIsFetching
          }
          size='large'
        >
          {!_.isEmpty(this.props.groupImagesWorkData) ? (
            this.props.groupImagesWorkData.hasOwnProperty(
              `img_group_${this.state.stepNumber}`
            ) &&
            this.props.groupImagesWorkData[`img_group_${this.state.stepNumber}`]
              .length ===
              this.props.imageGroupCount[
                `img_group_${this.state.stepNumber}`
              ] ? (
              <ImagesContainer
                imagesData={
                  this.props.groupImagesWorkData[
                    `img_group_${this.state.stepNumber}`
                  ]
                }
                loggedUserStatisticData={loggedUserStatisticData}
                onFinish={this.handleFinish}
                workingIds={this.props.workingIds}
                demoPage={true}
                userInfo={userInfo}
              />
            ) : null
          ) : null}
        </Spin>
      </div>
    );
  }
}

function mapStateToProps({
  auth,
  userStore,
  commonStore,
  qc_frStore,
  imagesStore
}) {
  return {
    userInfo: auth.userInfo,
    userStatisticData: userStore.userStatisticData,
    userStatisticDataIsFetching: userStore.userStatisticDataIsFetching,
    userStatisticDataErrorMessage: userStore.userStatisticDataErrorMessage,
    loggedUserStatisticData: userStore.loggedUserStatisticData,
    loggedUserStatisticDataIsFetching:
      userStore.loggedUserStatisticDataIsFetching,
    loggedUserStatisticDataErrorMessage:
      userStore.loggedUserStatisticDataErrorMessage,
    imageData: commonStore.imageData,
    domainData: commonStore.domainData,
    languagesData: commonStore.languagesData,
    originImageData: qc_frStore.originImageData,
    originImageHeaderData: qc_frStore.originImageHeaderData,
    downloadedImageData: qc_frStore.downloadedImageData,
    downloadedImageHeaderData: qc_frStore.downloadedImageHeaderData,
    imagesWorkData: qc_frStore.imagesWorkData,
    downloadedImageDataErrorMessage: qc_frStore.downloadedImageDataErrorMessage,
    domainImagesCountData: qc_frStore.domainImagesCountData,
    allImagesData: imagesStore.allImagesData,
    allImagesDataErrorMessage: imagesStore.allImagesDataErrorMessage,
    saveMultipleImagesStatusIsFetching:
      imagesStore.saveMultipleImagesStatusIsFetching,
    saveMultipleImagesStatusErrorMessage:
      imagesStore.saveMultipleImagesStatusErrorMessage,
    groupImagesWorkData: imagesStore.groupImagesWorkData,
    reservedIds: imagesStore.reservedIds,
    pendingIds: imagesStore.pendingIds,
    imageGroupCount: imagesStore.imageGroupCount,
    workingIds: imagesStore.workingIds
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAllImagesForProcessing: bindActionCreators(
      getAllImagesForProcessing,
      dispatch
    ),
    getImageData: bindActionCreators(getImageData, dispatch),
    changeGroupImagesContainerData: bindActionCreators(
      changeGroupImagesContainerData,
      dispatch
    ),
    saveMultipleImagesStatus: bindActionCreators(
      saveMultipleImagesStatus,
      dispatch
    ),
    setImageGroupCount: bindActionCreators(setImageGroupCount, dispatch),
    setImageWorkingIds: bindActionCreators(setImageWorkingIds, dispatch),
    saveMultipleOfflineImagesIDs: bindActionCreators(
      saveMultipleOfflineImagesIDs,
      dispatch
    ),
    getLoggedUserStatisticData: bindActionCreators(
      getLoggedUserStatisticData,
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImagesPage);
